"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingWizard = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const StorageService_1 = __importStar(require("@front/services/StorageService"));
const SignalService_1 = __importStar(require("@front/services/SignalService"));
const PopupService_1 = __importStar(require("@front/services/PopupService"));
const component_1 = require("@front/components/form-parts/form/component");
const component_2 = require("../site-menu/component");
const voices_helper_1 = require("@front/helpers/voices.helper");
const backendImport_1 = require("@front/backendImport");
const defaultModelSelection = {
    model: {
        label: "Claude Sonnet 4.5",
        value: "anthropic/claude-sonnet-4.5",
    },
    cost: 0.000015
};
//@ts-ignore                
let rwsTemplate = T.html `<template>
    <div class="container-fluid">
        <div class="dashboard-wrapper">
            <div class="firms-list row">
                <div class="form col-12 pb-lg-5">
                    <div class="row mb-2">
                        <div class="col">
                            <h1>
                                ${(0, fast_element_1.when)(x => x.onboardingId, (0, fast_element_1.html) `
                                    ${'onboarding.edit.title'.t()}
                                `, (0, fast_element_1.html) `
                                    ${'onboarding.title'.t()}
                                `)}
                            </h1>
                        </div>
                    </div>

                    
                    ${(0, fast_element_1.when)(x => x.message, (0, fast_element_1.html) `
                        <div class="alert alert-${x => x.message.type} mb-4">
                            ${x => x.message.text}
                        </div>
                    `)}

                    
                    ${(0, fast_element_1.when)(x => x.isLoading, (0, fast_element_1.html) `
                        <div class="loading-overlay active">
                            <div class="spinner-border" role="status">
                                <span class="sr-only">${'onboarding.loading'.t()}</span>
                            </div>
                        </div>
                    `)}

                    <div class="mb-5">
                        
                        <ul class="nav nav-tabs nav-fill mb-4" id="etapTabs" role="tablist">
                            
                            <li class="nav-item" role="presentation">
                                <button class="nav-link ${x => x.activeTab === 'profession' ? 'active' : ''}"
                                        type="button" 
                                        role="tab"
                                        @click="${x => x.switchToProfessionTab()}">
                                    ${(0, fast_element_1.when)(x => x.isProfessionStepCompleted(), (0, fast_element_1.html) `<i class="fas fa-check text-success mr-1"></i>`)}
                                    1. ${'onboarding.setup.avatar'.t()}
                                </button>
                            </li>
                            
                            
                            ${(0, fast_element_1.when)(x => x.selectedProfessionId && x.steps.length > 0, (0, fast_element_1.html) `
                                ${(0, fast_element_1.repeat)(x => x.steps, (0, fast_element_1.html) `
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link ${(x, c) => c.parent.activeTab === x.id ? 'active' : ''}"
                                                type="button" 
                                                role="tab"
                                                @click="${(x, c) => c.parent.switchToStepById(x.id)}">
                                            ${(0, fast_element_1.when)((x, c) => c.parent.isStepCompleted(c.index), (0, fast_element_1.html) `
                                                <i class="fas fa-check text-success mr-1"></i>
                                            `)}
                                            ${x => x.stepNumber}. ${x => x.title}
                                        </button>
                                    </li>
                                `)}
                                
                                
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link ${x => x.activeTab === 'knowledge' ? 'active' : ''}"
                                            type="button" 
                                            role="tab"
                                            @click="${x => x.switchToStepTab(x.steps.length)}">
                                        ${(0, fast_element_1.when)(x => x.knowledgeIds.length > 0, (0, fast_element_1.html) `
                                            <i class="fas fa-check text-success mr-1"></i>
                                        `)}
                                        ${x => x.steps.length + 2}. ${'onboarding.knowledge.base'.t()}
                                    </button>
                                </li>
                            `)}
                        </ul>

                        
                        <div class="progress-container mb-4">
                            <div class="progress" style="height: 8px;">
                                <div class="progress-bar bg-success" 
                                     role="progressbar" 
                                     :style="${x => `width: ${x.getProgressPercentage()}%`}"
                                     :aria-valuenow="${x => x.getProgressPercentage()}"
                                     aria-valuemin="0" 
                                     aria-valuemax="100">
                                </div>
                            </div>
                            <div class="progress-text text-center mt-2">
                                <small class="text-muted">
                                    ${x => x.getProgressPercentage()}% ${'onboarding.progress.complete'.t()} 
                                    ${(0, fast_element_1.when)(x => x.steps.length > 0, (0, fast_element_1.html) `
                                        (${x => (x.isProfessionStepCompleted() ? 1 : 0) + x.completedSteps.length} / ${x => 1 + x.steps.length} ${'onboarding.progress.steps'.t()})
                                    `)}
                                    ${(0, fast_element_1.when)(x => x.knowledgeIds.length > 0, (0, fast_element_1.html) `
                                        <span class="text-success ml-2">+ ${'onboarding.knowledge.bonus'.t()}</span>
                                    `)}
                                </small>
                            </div>
                        </div>

                        
                        <div class="tab-content" id="etapTabsContent">
                            
                            ${(0, fast_element_1.when)(x => x.activeTab === 'profession', (0, fast_element_1.html) `
                                <div class="tab-pane active" role="tabpanel">
                                    <div class="card p-4">
                                        <div class="row">
                                            <div class="col">
                                                <h5>${'onboarding.avatar.setup.title'.t()}</h5>
                                                
                                                <div class="form-group">
                                                    <label for="professionSelect">${'onboarding.profession.select.label'.t()}</label>
                                                    ${(0, fast_element_1.when)(x => x.professions.length === 0, (0, fast_element_1.html) `
                                                        <div class="alert alert-warning" role="alert">
                                                            <i class="fas fa-exclamation-triangle mr-2"></i>
                                                            ${'onboarding.profession.empty'.t()}
                                                        </div>
                                                    `, (0, fast_element_1.html) `
                                                        <select class="form-control" 
                                                                id="professionSelect" 
                                                                value="${x => x.selectedProfessionId}"
                                                                @change="${(x, c) => x.onProfessionChange(c.event)}">
                                                            <option value="">${'onboarding.profession.select.placeholder'.t()}</option>
                                                            ${(0, fast_element_1.repeat)(x => x.professions, (0, fast_element_1.html) `                                                                
                                                                <option ?selected="${(x, c) => c.parent.selectedProfessionId === x.id}" value="${x => x.id}">${x => x.name}</option>
                                                            `)}
                                                        </select>
                                                    `)}
                                                </div>

                                                
                                                <div class="avatar-config-section">
                                                    <div class="d-flex justify-content-between align-items-center mb-3">
                                                        <h6><i class="fas fa-user-cog mr-2"></i>${'onboarding.avatar.config.title'.t()}</h6>
                                                        <small class="text-muted">${x => x.getAvatarConfigCompletionText()}</small>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <label for="avatarName">${'onboarding.avatar.name.label'.t()} <span class="text-danger">${'onboarding.avatar.name.required'.t()}</span></label>
                                                                <input type="text" 
                                                                       class="form-control"
                                                                       id="avatarName"
                                                                       :value="${x => x.avatarConfig.name || ''}"
                                                                       @input="${(x, c) => x.onAvatarConfigChange('name', c.event.target.value)}"
                                                                       placeholder="${'onboarding.avatar.name.placeholder'.t()}">
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <label for="avatarAge">${'onboarding.avatar.age.label'.t()}</label>
                                                                <input type="text" 
                                                                       class="form-control"
                                                                       id="avatarAge"
                                                                       :value="${x => x.avatarConfig.age || ''}"
                                                                       @input="${(x, c) => x.onAvatarConfigChange('age', c.event.target.value)}"
                                                                       placeholder="${'onboarding.avatar.age.placeholder'.t()}">
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <label for="avatarGender">${'onboarding.avatar.gender.label'.t()}</label>
                                                                <select class="form-control"
                                                                        id="avatarGender"
                                                                        :value="${x => x.avatarConfig.gender || ''}"
                                                                        @change="${(x, c) => x.onAvatarConfigChange('gender', c.event.target.value)}">
                                                                    <option value="">${'onboarding.avatar.gender.placeholder'.t()}</option>
                                                                    <option value="male">${'onboarding.avatar.gender.male'.t()}</option>
                                                                    <option value="female">${'onboarding.avatar.gender.female'.t()}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <label for="avatarVoice">${'onboarding.avatar.voice.label'.t()}</label>
                                                                <select class="form-control"
                                                                        id="avatarVoice"
                                                                        :value="${x => x.avatarConfig.voice || ''}"
                                                                        @change="${(x, c) => x.onAvatarConfigChange('voice', c.event.target.value)}">
                                                                    ${(0, fast_element_1.repeat)(x => x.getVoiceOptions(), (0, fast_element_1.html) `
                                                                        <option value="${x => x.value}">${x => x.label}</option>
                                                                    `)}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <div class="form-group">
                                                                <label for="avatarDescription">${'onboarding.avatar.description.label'.t()}</label>
                                                                <textarea class="form-control"
                                                                          id="avatarDescription"
                                                                          rows="3"
                                                                          :value="${x => x.avatarConfig.description || ''}"
                                                                          @input="${(x, c) => x.onAvatarConfigChange('description', c.event.target.value)}"
                                                                          placeholder="${'onboarding.avatar.description.placeholder'.t()}"></textarea>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <div class="form-group">
                                                                <label for="avatarModel">${'onboarding.avatar.model.label'.t()}</label>
                                                                <simple-model-select 
                                                                    noAvatar="true"
                                                                    inForm="true"
                                                                    showAvatarProfession="false"
                                                                    value="${x => { var _a, _b; return (_b = (_a = x.avatarConfig) === null || _a === void 0 ? void 0 : _a.selectedModel) === null || _b === void 0 ? void 0 : _b.model.value; }}"                                                                   
                                                                ></simple-model-select>
                                                                <small class="form-text text-muted">${'onboarding.avatar.model.help'.t()}</small>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <label for="avatarImage">${'onboarding.avatar.image.label'.t()}</label>
                                                                <part-file-upload 
                                                                    class="form-part"                     
                                                                    :value="${x => x.avatarLogo}"
                                                                    name="logo" 
                                                                    accept="image/*"
                                                                    :onSelectFile="${(x, c) => x.onAvatarImageUpload.bind(x)}"
                                                                    placeholder="${'onboarding.avatar.image.placeholder'.t()}"
                                                                ></part-file-upload>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                ${(0, fast_element_1.when)(x => x.selectedProfessionId && x.avatarConfig.name, (0, fast_element_1.html) `
                                                    <div class="mt-3">
                                                        <button type="button" 
                                                                class="btn btn-primary"
                                                                @click="${x => x.handleNext()}">
                                                            ${'onboarding.button.continue'.t()}
                                                        </button>
                                                    </div>
                                                `)}
                                                
                                                ${(0, fast_element_1.when)(x => x.selectedProfessionId && !x.avatarConfig.name, (0, fast_element_1.html) `
                                                    <div class="mt-3">
                                                        <div class="alert alert-warning">
                                                            ${'onboarding.warning.name.required'.t()}
                                                        </div>
                                                    </div>
                                                `)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            `)}

                            
                            ${(0, fast_element_1.when)(x => x.activeTab !== 'profession' && x.activeTab !== 'knowledge' && x.steps.length > 0, (0, fast_element_1.html) `
                                <div class="tab-pane active" role="tabpanel">
                                    <div class="card p-4">
                                        <div class="row">
                                            <div class="col">
                                                ${(0, fast_element_1.when)(x => x.getCurrentStep(), (0, fast_element_1.html) `
                                                    <h5>${x => x.getCurrentStep().title}</h5>
                                                    ${(0, fast_element_1.when)(x => x.getCurrentStep().description, (0, fast_element_1.html) `
                                                        <p class="text-muted">${x => x.getCurrentStep().description}</p>
                                                    `)}                                       
                                                    
                                                    
                                                    <div class="questions-container">
                                                        ${(0, fast_element_1.when)(x => x.currentQuestions && x.currentQuestions.length > 0, (0, fast_element_1.html) `
                                                            ${(0, fast_element_1.repeat)(x => x.currentQuestions, (0, fast_element_1.html) `
                                                                <div class="form-group mb-4">
                                                                    <label class="form-label">
                                                                        ${x => x.title}
                                                                        ${(0, fast_element_1.when)(x => x.required, (0, fast_element_1.html) `<span class="text-danger">${'onboarding.questions.required'.t()}</span>`)}
                                                                    </label>
                                                                    ${(0, fast_element_1.when)(x => x.description, (0, fast_element_1.html) `
                                                                        <small class="form-text text-muted">${x => x.description}</small>
                                                                    `)}
                                                                    
                                                                    ${(0, fast_element_1.when)(x => x.type === 'text', (0, fast_element_1.html) `
                                                                        <input type="text" 
                                                                               class="form-control"
                                                                               :value="${(x, c) => c.parent.answers[x.id] || ''}"
                                                                               @input="${(x, c) => c.parent.onAnswerChange(x.id, c.event.target.value)}"
                                                                               placeholder="${'onboarding.questions.placeholder.text'.t()}">
                                                                    `)}
                                                                    
                                                                    ${(0, fast_element_1.when)(x => x.type === 'textarea', (0, fast_element_1.html) `
                                                                        <textarea class="form-control"
                                                                                  rows="3"
                                                                                  :value="${(x, c) => c.parent.answers[x.id] || ''}"
                                                                                  @input="${(x, c) => c.parent.onAnswerChange(x.id, c.event.target.value)}"
                                                                                  placeholder="${'onboarding.questions.placeholder.textarea'.t()}"></textarea>
                                                                    `)}
                                                                    
                                                                    ${(0, fast_element_1.when)(x => x.type === 'number', (0, fast_element_1.html) `
                                                                        <input type="number" 
                                                                               class="form-control"
                                                                               :value="${(x, c) => c.parent.answers[x.id] || ''}"
                                                                               @input="${(x, c) => c.parent.onAnswerChange(x.id, c.event.target.value)}"
                                                                               placeholder="${'onboarding.questions.placeholder.number'.t()}">
                                                                    `)}

                                                                    ${(0, fast_element_1.when)(x => x.type === 'select' && x.options, (0, fast_element_1.html) `
                                                                        <select class="form-control"
                                                                                :value="${(x, c) => c.parent.answers[x.id] || ''}"
                                                                                @change="${(x, c) => c.parent.onAnswerChange(x.id, c.event.target.value)}">
                                                                            <option value="">${'onboarding.questions.placeholder.select'.t()}</option>
                                                                            ${(0, fast_element_1.repeat)(x => x.options, (0, fast_element_1.html) `
                                                                                <option value="${x => typeof x === 'object' ? x.value : x}">
                                                                                    ${x => typeof x === 'object' ? x.label : x}
                                                                                </option>
                                                                            `)}
                                                                        </select>
                                                                    `)}

                                                                    ${(0, fast_element_1.when)(x => x.type === 'radio' && x.options, (0, fast_element_1.html) `
                                                                        <div class="form-check-group">
                                                                            ${(0, fast_element_1.repeat)(x => x.options, (0, fast_element_1.html) `
                                                                                <div class="form-check">
                                                                                    <input class="form-check-input" 
                                                                                           type="radio" 
                                                                                           name="${(x, c) => 'question_' + c.parent.id}"
                                                                                           id="${(x, c) => 'radio_' + c.parent.id + '_' + c.index}"
                                                                                           value="${x => typeof x === 'object' ? x.value : x}"
                                                                                           :checked="${(x, c) => {
    var _a, _b, _c, _d;
    const component = ((_a = c.parentContext) === null || _a === void 0 ? void 0 : _a.parent) || ((_c = (_b = c.parent) === null || _b === void 0 ? void 0 : _b.parentContext) === null || _c === void 0 ? void 0 : _c.parent);
    const questionId = c.parent.id;
    const optionValue = typeof x === 'object' ? x.value : x;
    return ((_d = component === null || component === void 0 ? void 0 : component.answers) === null || _d === void 0 ? void 0 : _d[questionId]) === optionValue;
}}"
                                                                                           @change="${(x, c) => {
    var _a, _b, _c, _d;
    const component = ((_a = c.parentContext) === null || _a === void 0 ? void 0 : _a.parent) || ((_c = (_b = c.parent) === null || _b === void 0 ? void 0 : _b.parentContext) === null || _c === void 0 ? void 0 : _c.parent);
    const questionId = c.parent.id;
    const optionValue = typeof x === 'object' ? x.value : x;
    (_d = component === null || component === void 0 ? void 0 : component.onAnswerChange) === null || _d === void 0 ? void 0 : _d.call(component, questionId, optionValue);
}}">
                                                                                    <label class="form-check-label" for="${(x, c) => 'radio_' + c.parent.id + '_' + c.index}">
                                                                                        ${x => typeof x === 'object' ? x.label : x}
                                                                                    </label>
                                                                                </div>
                                                                            `)}
                                                                        </div>
                                                                    `)}

                                                                    ${(0, fast_element_1.when)(x => x.type === 'checkbox' && x.options, (0, fast_element_1.html) `
                                                                        <div class="form-check-group">
                                                                            ${(0, fast_element_1.repeat)(x => x.options, (0, fast_element_1.html) `
                                                                                <div class="form-check">
                                                                                    <input class="form-check-input" 
                                                                                           type="checkbox" 
                                                                                           id="${(x, c) => 'checkbox_' + c.parent.id + '_' + c.index}"
                                                                                           value="${x => typeof x === 'object' ? x.value : x}"
                                                                                           :checked="${(x, c) => {
    var _a, _b, _c, _d;
    const component = ((_a = c.parentContext) === null || _a === void 0 ? void 0 : _a.parent) || ((_c = (_b = c.parent) === null || _b === void 0 ? void 0 : _b.parentContext) === null || _c === void 0 ? void 0 : _c.parent);
    const questionId = c.parent.id;
    const optionValue = typeof x === 'object' ? x.value : x;
    const answers = ((_d = component === null || component === void 0 ? void 0 : component.answers) === null || _d === void 0 ? void 0 : _d[questionId]) || [];
    return Array.isArray(answers) && answers.includes(optionValue);
}}"
                                                                                           @change="${(x, c) => {
    var _a, _b, _c;
    const component = ((_a = c.parentContext) === null || _a === void 0 ? void 0 : _a.parent) || ((_c = (_b = c.parent) === null || _b === void 0 ? void 0 : _b.parentContext) === null || _c === void 0 ? void 0 : _c.parent);
    const questionId = c.parent.id;
    const optionValue = typeof x === 'object' ? x.value : x;
    if (component === null || component === void 0 ? void 0 : component.onCheckboxChange) {
        component.onCheckboxChange(questionId, optionValue, c.event.target.checked);
    }
}}">
                                                                                    <label class="form-check-label" for="${(x, c) => 'checkbox_' + c.parent.id + '_' + c.index}">
                                                                                        ${x => typeof x === 'object' ? x.label : x}
                                                                                    </label>
                                                                                </div>
                                                                            `)}
                                                                        </div>
                                                                    `)}
                                                                </div>
                                                            `)}
                                                        `)}
                                                        
                                                        ${(0, fast_element_1.when)(x => !x.currentQuestions || x.currentQuestions.length === 0, (0, fast_element_1.html) `
                                                            <div class="alert alert-info">
                                                                <i class="fas fa-info-circle mr-2"></i>
                                                                ${'onboarding.questions.empty'.t()}
                                                            </div>
                                                        `)}
                                                    </div>
                                                `)}

                                                
                                                <div class="mt-4 d-flex justify-content-between">
                                                    ${(0, fast_element_1.when)(x => x.activeTab !== 'profession', (0, fast_element_1.html) `
                                                        <button type="button" 
                                                                class="btn btn-secondary"
                                                                @click="${x => x.previousStep()}">
                                                            ${'onboarding.button.previous'.t()}
                                                        </button>
                                                    `)}
                                                    
                                                    <button type="button" 
                                                            class="btn btn-primary"
                                                            @click="${x => x.handleNext()}">
                                                        ${(0, fast_element_1.when)(x => x.isLastStep(), (0, fast_element_1.html) `${'onboarding.button.complete'.t()}`)}
                                                        ${(0, fast_element_1.when)(x => !x.isLastStep(), (0, fast_element_1.html) `${'onboarding.button.next'.t()}`)}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            `)}

                            
                            ${(0, fast_element_1.when)(x => x.activeTab === 'knowledge', (0, fast_element_1.html) `
                                <div class="tab-pane active" role="tabpanel">
                                    <div class="card p-4">
                                        <div class="row">
                                            <div class="col">
                                                <h5><i class="fas fa-book mr-2"></i>${'onboarding.knowledge.title'.t()}</h5>
                                                <p class="text-muted">${'onboarding.knowledge.description'.t()}</p>
                                                <div class="step-progress">
                                                    <small class="text-muted">${'onboarding.knowledge.final.step'.t()}</small>
                                                </div>
                                                
                                                
                                                <div class="knowledge-container mt-4">
                                                    <knowledge-picker 
                                                        forcedShow="true"
                                                        :selectedIds="${x => x.knowledgeIds.join(',')}"
                                                        :initial-show="true"
                                                        label="${'onboarding.knowledge.label'.t()}"
                                                        placeholder="${'onboarding.knowledge.placeholder'.t()}"
                                                        @selectionChanged="${(x, c) => x.onKnowledgeSelectionChanged(c.event)}"
                                                    ></knowledge-picker>
                                                    
                                                    ${(0, fast_element_1.when)(x => x.knowledgeIds.length === 0, (0, fast_element_1.html) `
                                                        <div class="alert alert-info mt-3">
                                                            <i class="fas fa-info-circle mr-2"></i>
                                                            ${'onboarding.knowledge.skip.info'.t()}
                                                        </div>
                                                    `)}
                                                    
                                                    ${(0, fast_element_1.when)(x => x.knowledgeIds.length > 0, (0, fast_element_1.html) `
                                                        <div class="alert alert-success mt-3">
                                                            <i class="fas fa-check-circle mr-2"></i>
                                                            ${x => x.knowledgeIds.length} ${'onboarding.knowledge.count'.t()} 
                                                            ${(0, fast_element_1.when)(x => x.knowledgeIds.length === 1, (0, fast_element_1.html) `${'onboarding.knowledge.selected.single'.t()}`)}
                                                            ${(0, fast_element_1.when)(x => x.knowledgeIds.length > 1, (0, fast_element_1.html) `${'onboarding.knowledge.selected.multiple'.t()}`)}
                                                        </div>
                                                    `)}
                                                </div>

                                                
                                                <div class="mt-4 d-flex justify-content-between">
                                                    <button type="button" 
                                                            class="btn btn-secondary"
                                                            @click="${x => x.previousStep()}">
                                                        ${'onboarding.button.previous'.t()}
                                                    </button>
                                                    
                                                    <button type="button" 
                                                            class="btn btn-success btn-lg"
                                                            @click="${x => x.handleNext()}">
                                                        <i class="fas fa-check mr-2"></i>${'onboarding.button.complete'.t()}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            `)}
                        </div>

                        
                        <div class="text-center mt-4">
                            <nav class="d-inline-block" aria-label="${'onboarding.pagination.navigation'.t()}">
                                <ul class="pagination pagination-sm pagination-steps justify-content-center" id="paginationNav">
                                    
                                    <li class="page-item ${x => (x.activeTab !== 'profession') ? '' : 'disabled'}" id="prevBtn">
                                        <button class="prev page-link" 
                                                @click="${x => x.previousStep()}"
                                                ?disabled="${x => x.activeTab === 'profession'}"
                                                aria-label="${'onboarding.button.previous'.t()}">
                                            <i class="simple-icon-arrow-left"></i>
                                        </button>
                                    </li>
                                    
                                    
                                    <li class="page-item page-item-tab ${x => x.activeTab === 'profession' ? 'active' : ''}">
                                        <button class="page-link" @click="${x => x.switchToProfessionTab()}">
                                            ${'onboarding.pagination.step.1'.t()}
                                        </button>
                                    </li>
                                    
                                    
                                    ${(0, fast_element_1.when)(x => x.selectedProfessionId && x.steps.length > 0, (0, fast_element_1.html) `
                                        ${(0, fast_element_1.repeat)(x => x.steps, (0, fast_element_1.html) `
                                            <li class="page-item page-item-tab ${(x, c) => c.parent.activeTab === x.id ? 'active' : ''}">
                                                <button class="page-link" 
                                                        @click="${(x, c) => c.parent.switchToStepById(x.id)}">
                                                    ${'onboarding.pagination.step'.t()} ${x => x.stepNumber}
                                                </button>
                                            </li>
                                        `)}
                                        
                                        
                                        <li class="page-item page-item-tab ${x => x.activeTab === 'knowledge' ? 'active' : ''}">
                                            <button class="page-link" 
                                                    @click="${x => x.switchToStepTab(x.steps.length)}">
                                                ${'onboarding.pagination.step'.t()} ${x => x.steps.length + 2}
                                            </button>
                                        </li>
                                    `)}
                                    
                                    
                                    <li class="page-item" id="nextBtn">
                                        <button class="next page-link" 
                                                @click="${x => x.handleNext()}">
                                            <i class="simple-icon-arrow-right"></i>
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>`;
require("./styles/layout.scss");
const styles = T.css `.nav-fill .nav-item {
  flex: inherit;
}

@media (max-width: 768px) {
  .nav-tabs .nav-link {
    padding: 0.375rem 0.75rem;
    font-size: 0.875rem;
  }
}
.onboarding-container {
  padding: 20px;
  min-height: 100vh;
  background-color: #f8f9fa;
}
.onboarding-container .dashboard-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 30px;
}
.onboarding-container .message-container {
  margin-bottom: 20px;
  padding: 15px;
  border-radius: 5px;
}
.onboarding-container .message-container.hidden {
  display: none;
}
.onboarding-container .loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.onboarding-container .loading-overlay.hidden {
  display: none;
}
.onboarding-container .loading-overlay.active {
  display: flex;
}
.onboarding-container .step-progress {
  margin-top: 0.5rem;
}
.onboarding-container .step-progress .text-muted {
  color: #6c757d !important;
}
.onboarding-container .progress-container {
  margin-bottom: 1.5rem;
}
.onboarding-container .progress-container .progress {
  border-radius: 4px;
  overflow: hidden;
  background-color: #e9ecef;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
}
.onboarding-container .progress-container .progress .progress-bar {
  transition: width 0.6s ease;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  background: linear-gradient(45deg, #28a745, #20c997);
}
.onboarding-container .progress-container .progress-text {
  font-size: 0.875rem;
  color: #6c757d;
}
.onboarding-container .progress-container .progress-text .text-muted {
  font-weight: 500;
}
.onboarding-container .avatar-config-section {
  border-top: 1px solid #e9ecef;
  padding-top: 1.5rem;
  margin-top: 1.5rem;
}
.onboarding-container .avatar-config-section h6 {
  color: #495057;
  margin-bottom: 1rem;
  font-weight: 600;
}
.onboarding-container .questions-container .form-group {
  margin-bottom: 1.5rem;
}
.onboarding-container .pagination-steps .page-item + .page-item:not(:last-child) .page-link {
  border: none !important;
  padding: 0 10px;
}
@media (max-width: 768px) {
  .onboarding-container {
    padding: 10px;
  }
  .onboarding-container .dashboard-wrapper {
    padding: 20px;
  }
  .onboarding-container .card-body {
    padding: 1rem;
  }
}

.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  border: 0.25em solid currentcolor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border 0.75s linear infinite;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}
.sr-only {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.page-item.active .page-link {
  border: none;
}

.page-item .page-link:hover {
  border: none;
}`;
const shadowOptions = { "mode": "open" };
let OnboardingWizard = class OnboardingWizard extends client_1.RWSViewComponent {
    constructor(storageService, signalService, popupService) {
        super();
        this.storageService = storageService;
        this.signalService = signalService;
        this.popupService = popupService;
        this.avatarId = ''; // Optional - will be set later when avatar is created
        this.professions = [];
        this.steps = [];
        this.currentQuestions = [];
        this.selectedProfessionId = null;
        this.currentStepIndex = 0;
        this.answers = {};
        this.completedSteps = [];
        this.knowledgeIds = [];
        this.avatarLogo = null;
        this.avatarConfig = {};
        this.isLoading = false;
        this.message = null;
        this.onboardingId = null;
        this.activeTab = 'profession'; // 'profession', 'knowledge', or step ID
        this.totalStepsWithKnowledge = 0; // Include knowledge step in total count
        this.voiceOptions = [];
        this.selectedAzureVoice = null;
        this.sendSubmit = component_1.FormComponent.sendSubmitEvent;
    }
    async connectedCallback() {
        super.connectedCallback();
        this.avatarConfig = { ...this.avatarConfig, selectedModel: defaultModelSelection };
        await this.loadProfessions();
        await this.loadAzureVoices();
        this.updateVoiceOptions();
        if (this.onboardingId) {
            await this.loadOnboardingById(this.onboardingId);
        }
        this.on('model:selected', (event) => {
            const selectedModel = event.detail;
            if (selectedModel) {
                this.onModelSelectionChanged(selectedModel);
            }
        });
        // await this.loadExistingOnboarding();        
    }
    async loadExistingOnboarding() {
        var _a, _b, _c, _d, _e, _f, _g;
        if (!this.avatarId)
            return;
        try {
            const response = await this.apiService.back.get('onboarding.list', {
                queryParams: { avatar_id: String(this.avatarId) }
            });
            if (response.success && response.data && response.data.length > 0) {
                const onboarding = response.data[0]; // Get the first (most recent) onboarding
                this.onboardingId = String(onboarding.id);
                this.selectedProfessionId = onboarding.profession.id;
                this.currentStepIndex = onboarding.current_step || 0;
                this.completedSteps = onboarding.completed_steps || [];
                this.knowledgeIds = onboarding.knowledge_ids || [];
                this.avatarConfig = {
                    name: ((_a = onboarding.avatar_config) === null || _a === void 0 ? void 0 : _a.name) || '',
                    age: ((_b = onboarding.avatar_config) === null || _b === void 0 ? void 0 : _b.age) || '',
                    gender: ((_c = onboarding.avatar_config) === null || _c === void 0 ? void 0 : _c.gender) || '',
                    voice: ((_d = onboarding.avatar_config) === null || _d === void 0 ? void 0 : _d.voice) || '',
                    description: ((_e = onboarding.avatar_config) === null || _e === void 0 ? void 0 : _e.description) || '',
                    selectedModel: ((_f = onboarding.avatar_config) === null || _f === void 0 ? void 0 : _f.selectedModel) || defaultModelSelection
                };
                // Load avatar logo if exists
                this.avatarLogo = onboarding.logo || null;
                if ((_g = onboarding.data) === null || _g === void 0 ? void 0 : _g.answers) {
                    this.answers = onboarding.data.answers;
                }
                // Reload voices after gender is loaded
                this.updateVoiceOptions();
                // Load steps for the profession
                if (this.selectedProfessionId) {
                    await this.loadStepsForProfession(this.selectedProfessionId);
                    // If we have a current step, switch to it and load questions
                    if (onboarding.status === 'in_progress' && this.currentStepIndex < this.steps.length) {
                        this.switchToStepTab(this.currentStepIndex);
                    }
                }
            }
        }
        catch (error) {
            console.error('Error loading existing onboarding:', error);
            // Don't show error message as this is optional
        }
    }
    async loadOnboardingById(onboardingId) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (!onboardingId)
            return;
        this.isLoading = true;
        try {
            const response = await this.apiService.back.get('onboarding.get', {
                routeParams: { id: String(onboardingId) }
            });
            if (response.success && response.data) {
                const onboarding = response.data;
                this.onboardingId = onboarding.id;
                this.selectedProfessionId = onboarding.profession.id;
                console.log(onboarding.profession);
                console.log(this.professions);
                this.currentStepIndex = onboarding.current_step || 0;
                this.completedSteps = onboarding.completed_steps || [];
                this.knowledgeIds = onboarding.knowledge_ids || [];
                this.avatarId = onboarding.avatar ? onboarding.avatar.id : '';
                this.avatarConfig = {
                    name: ((_a = onboarding.avatar_config) === null || _a === void 0 ? void 0 : _a.name) || '',
                    age: ((_b = onboarding.avatar_config) === null || _b === void 0 ? void 0 : _b.age) || '',
                    gender: ((_c = onboarding.avatar_config) === null || _c === void 0 ? void 0 : _c.gender) || '',
                    voice: ((_d = onboarding.avatar_config) === null || _d === void 0 ? void 0 : _d.voice) || '',
                    description: ((_e = onboarding.avatar_config) === null || _e === void 0 ? void 0 : _e.description) || '',
                    selectedModel: ((_f = onboarding.avatar_config) === null || _f === void 0 ? void 0 : _f.selectedModel) || defaultModelSelection
                };
                // Load avatar logo if exists
                this.avatarLogo = onboarding.logo || null;
                if ((_g = onboarding.data) === null || _g === void 0 ? void 0 : _g.answers) {
                    this.answers = onboarding.data.answers;
                    console.log('Loaded onboarding answers:', this.answers);
                    // Force reactivity update to ensure form fields get populated
                    setTimeout(() => {
                        console.log('DEBUG: Forcing reactivity update for answers');
                        this.answers = { ...this.answers };
                    }, 100);
                }
                else {
                    console.log('No answers found in onboarding data');
                }
                // Reload voices after gender is loaded
                this.updateVoiceOptions();
                // Load steps for the profession
                if (this.selectedProfessionId) {
                    await this.loadStepsForProfession(this.selectedProfessionId);
                    // If we have a current step, switch to it and load questions
                    if (onboarding.status === 'in_progress' && this.currentStepIndex < this.steps.length) {
                        this.switchToStepTab(this.currentStepIndex);
                    }
                }
                // Force one more reactivity update after all data is loaded
                setTimeout(() => {
                    var _a, _b;
                    console.log('DEBUG: Final reactivity update after all data loaded');
                    console.log('DEBUG: avatarConfig:', this.avatarConfig);
                    console.log('DEBUG: avatarConfig.selectedModel:', this.avatarConfig.selectedModel);
                    console.log('DEBUG: model value for simple-model-select:', (_b = (_a = this.avatarConfig.selectedModel) === null || _a === void 0 ? void 0 : _a.model) === null || _b === void 0 ? void 0 : _b.value);
                    console.log('DEBUG: answers:', this.answers);
                    // Force updates to all observable properties
                    this.avatarConfig = { ...this.avatarConfig };
                    this.answers = { ...this.answers };
                }, 200);
            }
            else {
                this.showMessage('onboarding.error.load_failed'.t(), 'error');
            }
        }
        catch (error) {
            console.error('Error loading onboarding by ID:', error);
            this.showMessage('onboarding.error.load_general'.t(), 'error');
        }
        finally {
            this.isLoading = false;
        }
    }
    async loadProfessions() {
        this.isLoading = true;
        try {
            const response = await this.apiService.back.get('profession.list');
            if (response.success) {
                this.professions = response.data || [];
            }
            else {
                this.showMessage('onboarding.error.professions_load_failed'.t(), 'error');
            }
        }
        catch (error) {
            console.error('Error loading professions:', error);
            this.showMessage('onboarding.error.professions_load_general'.t(), 'error');
        }
        finally {
            this.isLoading = false;
        }
    }
    /**
     * Load available Azure voices from the API using AzureVoicesHelper
     */
    async loadAzureVoices() {
        try {
            const voices = await voices_helper_1.AzureVoicesHelper.loadAzureVoicesFromAPI(this.apiService);
            console.log('🎤 [OnboardingWizard] Loaded', voices.length, 'Azure voices');
        }
        catch (error) {
            console.error('Failed to load Azure voices:', error);
        }
    }
    /**
     * Update voice options based on gender selection
     */
    updateVoiceOptions() {
        var _a;
        const options = [{ label: 'onboarding.avatar.voice.placeholder'.t(), value: '' }];
        const currentGender = (_a = this.avatarConfig) === null || _a === void 0 ? void 0 : _a.gender;
        if (currentGender === 'male') {
            const maleVoices = voices_helper_1.AzureVoicesHelper.getVoicesByGender('male');
            options.push(...maleVoices.map(voice => ({
                label: `🎤 ${voice.displayName} (${voice.language})`,
                value: voice.name
            })));
        }
        else if (currentGender === 'female') {
            const femaleVoices = voices_helper_1.AzureVoicesHelper.getVoicesByGender('female');
            options.push(...femaleVoices.map(voice => ({
                label: `🎤 ${voice.displayName} (${voice.language})`,
                value: voice.name
            })));
        }
        else {
            // Show all voices if no gender selected
            const allVoices = voices_helper_1.AzureVoicesHelper.getAzureVoices();
            options.push(...allVoices.map(voice => ({
                label: `🎤 ${voice.displayName} (${voice.language}) ${voice.gender === 'male' ? '👨' : '👩'}`,
                value: voice.name
            })));
        }
        this.voiceOptions = options;
    }
    /**
     * Handle voice selection change
     */
    onVoiceChange(voice) {
        this.avatarConfig.voice = voice;
        // Update selected Azure voice using helper
        this.selectedAzureVoice = voices_helper_1.AzureVoicesHelper.findAzureVoiceByName(voice);
        // Trigger reactivity
        this.avatarConfig = { ...this.avatarConfig };
    }
    getVoiceOptions() {
        return this.voiceOptions;
    }
    professionsChanged(odlVal, newVal) {
        // If we have a selected profession ID, load steps for it
        if (newVal.length && this.selectedProfessionId) {
            this.loadStepsForProfession(this.selectedProfessionId);
        }
    }
    loadVoices() {
        // Update voice options when called (maintaining backward compatibility)
        this.updateVoiceOptions();
    }
    async onProfessionChange(event) {
        const target = event.target;
        this.selectedProfessionId = target.value;
        if (this.selectedProfessionId) {
            await this.loadStepsForProfession(this.selectedProfessionId);
        }
    }
    async loadStepsForProfession(professionId) {
        this.isLoading = true;
        try {
            // Load steps for the selected profession using the new n:n relationship
            const response = await this.apiService.back.get('onboarding.profession.steps', {
                routeParams: { profession_id: String(professionId) }
            });
            if (response.success) {
                // Add index numbers to each step object for reliable identification
                this.steps = (response.data || []).map((step, index) => ({
                    ...step,
                    stepNumber: index + 2 // Start from 2 since 1 is the profession setup
                }));
                // Update total steps including the knowledge upload step
                this.totalStepsWithKnowledge = this.steps.length + 2; // +1 for profession setup, +1 for knowledge upload
                this.currentStepIndex = 0;
                // Don't auto-load questions here since we're not switching to step tab yet
            }
            else {
                this.showMessage('onboarding.error.steps_load_failed'.t(), 'error');
            }
        }
        catch (error) {
            console.error('Error loading steps:', error);
            this.showMessage('onboarding.error.steps_load_general'.t(), 'error');
        }
        finally {
            this.isLoading = false;
        }
    }
    async loadQuestionsForStep(stepId) {
        this.isLoading = true;
        try {
            const response = await this.apiService.back.get('question.list', {
                queryParams: { step_id: stepId }
            });
            if (response.success) {
                this.currentQuestions = (response.data || []).sort((a, b) => a.order - b.order);
            }
            else {
                this.showMessage('onboarding.error.questions_load_failed'.t(), 'error');
            }
        }
        catch (error) {
            console.error('Error loading questions:', error);
            this.showMessage('onboarding.error.questions_load_general'.t(), 'error');
        }
        finally {
            this.isLoading = false;
        }
    }
    avatarConfigChanged(oldVal, newVal) {
        if ((oldVal === null || oldVal === void 0 ? void 0 : oldVal.gender) !== (newVal === null || newVal === void 0 ? void 0 : newVal.gender)) {
            if (newVal.voice && newVal.gender) {
                const voices = voices_helper_1.AzureVoicesHelper.getVoicesByGender(newVal.gender);
                const isVoiceValid = voices.some(voice => voice.name === newVal.voice);
                if (!isVoiceValid) {
                    setTimeout(() => {
                        this.avatarConfig = { ...this.avatarConfig, voice: '' };
                    }, 10);
                }
            }
        }
    }
    onAnswerChange(questionId, value) {
        this.answers = {
            ...this.answers,
            [questionId]: value
        };
    }
    onAvatarConfigChange(field, value) {
        const oldConfig = { ...this.avatarConfig };
        this.avatarConfig = {
            ...this.avatarConfig,
            [field]: value
        };
        // If gender changed, update voice options and clear voice if it's not valid for the new gender
        if (field === 'gender' && oldConfig.gender !== value) {
            this.updateVoiceOptions();
            // Clear voice if current voice is not compatible with new gender
            if (this.avatarConfig.voice && value) {
                const selectedVoice = voices_helper_1.AzureVoicesHelper.findAzureVoiceByName(this.avatarConfig.voice);
                const isVoiceValidForGender = selectedVoice &&
                    (value === selectedVoice.gender);
                if (!isVoiceValidForGender) {
                    this.avatarConfig = { ...this.avatarConfig, voice: '' };
                    this.selectedAzureVoice = null;
                }
            }
        }
        // If voice changed, update selected Azure voice
        if (field === 'voice') {
            this.selectedAzureVoice = voices_helper_1.AzureVoicesHelper.findAzureVoiceByName(value);
        }
    }
    onModelSelectionChanged(selectedModel) {
        if (selectedModel) {
            this.avatarConfig = {
                ...this.avatarConfig,
                selectedModel: selectedModel
            };
        }
    }
    onAvatarImageUpload(event) {
        const fileData = event.data;
        if (fileData) {
            this.avatarLogo = fileData; // Store the entire file object like avatar form does
        }
    }
    onKnowledgeSelectionChanged(event) {
        this.knowledgeIds = event.detail.selectedIds || [];
    }
    onCheckboxChange(questionId, optionValue, isChecked) {
        const currentValues = this.answers[questionId] || [];
        let updatedValues;
        if (isChecked) {
            updatedValues = [...currentValues, optionValue];
        }
        else {
            updatedValues = currentValues.filter((value) => value !== optionValue);
        }
        console.log(`Checkbox change - Question ${questionId}, Option ${optionValue}, Checked: ${isChecked}, New values:`, updatedValues);
        this.onAnswerChange(questionId, updatedValues);
    }
    async saveOnboarding() {
        var _a, _b;
        if (!this.selectedProfessionId) {
            this.showMessage('onboarding.error.profession_required'.t(), 'error');
            return;
        }
        // Avatar ID is now optional - avatar will be created later from onboarding data
        // Additional validation for completion
        if (this.isLastStep() || this.activeTab === 'knowledge') {
            if (!this.validateAvatarConfig()) {
                return;
            }
            // Validate all completed steps have required answers
            for (let i = 0; i < this.steps.length; i++) {
                if (this.steps[i] && this.steps[i].questions) {
                    for (const question of this.steps[i].questions) {
                        if (question.required && (!this.answers[question.id] || this.answers[question.id] === '')) {
                            this.showMessage(`${'onboarding.error.complete_required_step'.t()} "${this.steps[i].title}"`, 'warning');
                            return;
                        }
                    }
                }
            }
            // Also validate that all regular steps have been completed
            for (let i = 0; i < this.steps.length; i++) {
                if (!this.completedSteps.includes(i)) {
                    this.showMessage(`${'onboarding.error.complete_step'.t()} "${this.steps[i].title}" ${'onboarding.error.before_finishing'.t()}`, 'warning');
                    this.switchToStepTab(i);
                    return;
                }
            }
        }
        this.isLoading = true;
        try {
            // Mark current step as completed if not already (including knowledge step)
            if (this.activeTab === 'knowledge' || this.isKnowledgeStep()) {
                // For knowledge step, mark all regular steps as completed if we're finishing
                for (let i = 0; i < this.steps.length; i++) {
                    if (!this.completedSteps.includes(i)) {
                        this.completedSteps = [...this.completedSteps, i];
                    }
                }
            }
            else if (!this.completedSteps.includes(this.currentStepIndex)) {
                this.completedSteps = [...this.completedSteps, this.currentStepIndex];
            }
            // Prepare structured data with answers organized by questions
            const structuredAnswers = {};
            const stepQuestions = {};
            // Organize answers by step and question
            this.steps.forEach((step, stepIndex) => {
                if (step.questions && step.questions.length > 0) {
                    stepQuestions[step.id] = {};
                    step.questions.forEach(question => {
                        if (this.answers[question.id] !== undefined) {
                            stepQuestions[step.id][question.id] = {
                                question_title: question.title,
                                question_type: question.type,
                                answer: this.answers[question.id]
                            };
                        }
                    });
                }
            });
            const payload = {
                profession_id: this.selectedProfessionId,
                status: (this.isLastStep() || this.activeTab === 'knowledge') ? 'completed' : 'in_progress',
                current_step: this.currentStepIndex,
                completed_steps: this.completedSteps,
                data: {
                    answers: this.answers, // Raw answers by question ID
                    structured_answers: stepQuestions, // Organized by step and question
                    steps: this.steps.map(step => ({
                        id: step.id,
                        title: step.title,
                        order: step.order
                    })),
                    completion_date: (this.isLastStep() || this.activeTab === 'knowledge') ? new Date().toISOString() : null
                },
                knowledge_ids: this.knowledgeIds,
                avatar_config: this.avatarConfig,
                logo: this.avatarLogo // Include logo field like avatar form does
            };
            // Add avatar_id only if it exists
            if (this.avatarId) {
                payload.avatar_id = this.avatarId;
            }
            console.log('Saving onboarding with answers:', this.answers);
            console.log('Full payload:', payload);
            const response = this.onboardingId
                ? await this.apiService.back.put('onboarding.update', payload, {
                    routeParams: { id: String(this.onboardingId) }
                })
                : await this.apiService.back.post('onboarding.create', payload);
            if (response.success) {
                this.onboardingId = ((_a = response.data) === null || _a === void 0 ? void 0 : _a.id) ? String(response.data.id) : null;
                if (this.isLastStep() || this.activeTab === 'knowledge') {
                    // Check if avatar was created from onboarding
                    const createdAvatarId = (_b = response.data) === null || _b === void 0 ? void 0 : _b.avatar_id;
                    this.showMessage('onboarding.success.completed'.t(), 'success');
                    // Store avatar in storage service if created
                    if (createdAvatarId) {
                        this.avatarId = String(createdAvatarId);
                        this.storageService.set('ai.selectedAvatar', String(createdAvatarId));
                        // Also clear any existing model selection since we now have an avatar
                        this.storageService.clear('ai.selectedProvider');
                        this.storageService.clear('ai.selectedModel');
                        this.storageService.set('ai.selectedAIProvider', 'inthub');
                        console.log('🎭 Onboarding: Avatar created, triggering avatar reload signal');
                        // Trigger avatar reload in all simple-model-select components
                        // SimpleModelSelect.triggerAvatarReload(this.signalService);
                    }
                    // Emit completion event for parent components
                    this.$emit('onboarding-completed', {
                        onboardingId: this.onboardingId,
                        avatarId: createdAvatarId ? String(createdAvatarId) : this.avatarId,
                        professionId: this.selectedProfessionId,
                        avatarConfig: this.avatarConfig,
                        answers: this.answers
                    });
                    // Optional: redirect after completion
                    // Wait a bit for avatar reload signal to propagate before redirecting
                    setTimeout(() => {
                        console.log('🚀 Onboarding: Redirecting to chat after avatar reload');
                        this.notifyService.notify('onboarding.notify.done'.t(), 'info');
                        component_2.SiteMenu.goto.bind(this)('/ai/chat');
                    }, 1500); // Reduced from 2000ms but still allows time for avatar reload
                }
                else {
                    this.showMessage('onboarding.success.progress_saved'.t(), 'success');
                }
            }
            else {
                this.showMessage(response.error || 'onboarding.error.save_failed'.t(), 'error');
            }
        }
        catch (error) {
            console.error('Error saving onboarding:', error);
            this.showMessage('onboarding.error.save_general'.t(), 'error');
        }
        finally {
            this.isLoading = false;
        }
    }
    getCurrentStep() {
        return this.steps[this.currentStepIndex] || null;
    }
    isFirstStep() {
        return this.currentStepIndex === 0;
    }
    isLastStep() {
        // Last step is now the knowledge upload step, which comes after all loaded steps
        return this.currentStepIndex === this.steps.length || this.activeTab === 'knowledge'; // Knowledge step is at steps.length index
    }
    isKnowledgeStep() {
        return this.currentStepIndex === this.steps.length;
    }
    showMessage(text, type) {
        this.message = { text, type };
        setTimeout(() => {
            this.message = null;
        }, 5000);
    }
    validateCurrentStep() {
        if (this.isKnowledgeStep() || this.activeTab === 'knowledge') {
            // Knowledge step is optional, so always valid
            return true;
        }
        const currentStep = this.getCurrentStep();
        if (!currentStep)
            return false;
        for (const question of this.currentQuestions) {
            const answer = this.answers[question.id];
            let isEmpty = false;
            // Handle different question types for empty validation
            if (question.type === 'checkbox') {
                isEmpty = !answer || !Array.isArray(answer) || answer.length === 0;
            }
            else {
                isEmpty = !answer || answer === '' || answer === null || answer === undefined;
            }
            if (question.required && isEmpty) {
                this.showMessage(`${'onboarding.error.answer_required'.t()}: ${question.title}`, 'warning');
                return false;
            }
        }
        return true;
    }
    validateAvatarConfig() {
        if (!this.avatarConfig.name || this.avatarConfig.name.trim() === '') {
            this.showMessage('onboarding.error.avatar_name_required'.t(), 'warning');
            return false;
        }
        if (!this.avatarConfig.selectedModel || !this.avatarConfig.selectedModel.model) {
            this.popupService.alert('onboarding.error.model_required'.t());
            return false;
        }
        return true;
    }
    async handleNext() {
        if (this.activeTab === 'profession') {
            if (this.selectedProfessionId && this.avatarConfig.name && this.avatarConfig.name.trim()) {
                this.switchToStepTab(0);
                return;
            }
            else if (!this.selectedProfessionId) {
                this.showMessage('onboarding.error.profession_select_first'.t(), 'warning');
                return;
            }
            else if (!this.avatarConfig.name || !this.avatarConfig.name.trim()) {
                this.showMessage('onboarding.error.avatar_name_provide'.t(), 'warning');
                return;
            }
        }
        // Handle step navigation for both regular steps and knowledge step
        if (this.activeTab !== 'profession') {
            if (this.validateCurrentStep()) {
                if (this.isLastStep() || this.activeTab === 'knowledge') {
                    await this.saveOnboarding();
                }
                else {
                    await this.nextStep();
                }
            }
        }
    }
    // Helper method for template
    getProfessionOptions() {
        return this.professions;
    }
    // Helper method for templates
    renderQuestionsByType(question, questionIndex) {
        // This will be called from template
        return question;
    }
    // Helper method to check if avatar config is valid for proceeding
    isAvatarConfigValid() {
        return this.avatarConfig.name !== undefined && this.avatarConfig.name.trim() !== '';
    }
    // Helper method to get avatar config completion status for UI
    getAvatarConfigCompletionText() {
        const fields = ['name', 'age', 'voice', 'description'];
        const filledFields = fields.filter(field => {
            var _a;
            return this.avatarConfig[field] &&
                ((_a = this.avatarConfig[field]) === null || _a === void 0 ? void 0 : _a.toString().trim()) !== '';
        });
        return `${filledFields.length}/${fields.length} ${'onboarding.fields_completed'.t()}`;
    }
    // Template condition helpers
    isStepActive(stepIndex) {
        const step = this.steps[stepIndex];
        return step && this.activeTab === String(step.id) && this.selectedProfessionId !== '';
    }
    isProfessionTabActive() {
        return this.activeTab === 'profession';
    }
    getStepTabClass(stepIndex) {
        const baseClass = 'nav-link';
        // Check if this step is active
        if (stepIndex === this.steps.length) {
            // Knowledge step
            if (this.activeTab === 'knowledge') {
                return `${baseClass} active`;
            }
            if (this.knowledgeIds.length > 0) {
                return `${baseClass} completed`;
            }
        }
        else {
            // Regular step - check by step ID
            const step = this.steps[stepIndex];
            if (step && this.activeTab === String(step.id)) {
                return `${baseClass} active`;
            }
            if (this.completedSteps.includes(stepIndex)) {
                return `${baseClass} completed`;
            }
        }
        return baseClass;
    }
    getProfessionTabClass() {
        const baseClass = 'nav-link';
        if (this.isProfessionTabActive()) {
            return `${baseClass} active`;
        }
        if (this.selectedProfessionId && this.avatarConfig.name) {
            return `${baseClass} completed`;
        }
        return baseClass;
    }
    isStepCompleted(stepIndex) {
        if (stepIndex === this.steps.length) {
            // Knowledge step
            return this.knowledgeIds.length > 0;
        }
        return this.completedSteps.includes(stepIndex);
    }
    isProfessionStepCompleted() {
        return this.selectedProfessionId !== '' &&
            this.avatarConfig.name !== undefined &&
            this.avatarConfig.name.trim() !== '';
    }
    getProgressPercentage() {
        // Total mandatory steps: profession + regular steps (knowledge is optional)
        const totalMandatorySteps = 1 + this.steps.length; // 1 for profession, n for regular steps
        if (totalMandatorySteps === 0)
            return 0;
        let completedCount = 0;
        // Profession step
        if (this.isProfessionStepCompleted()) {
            completedCount += 1;
        }
        // Regular steps
        completedCount += this.completedSteps.length;
        // Calculate percentage based on mandatory steps only
        const percentage = Math.round((completedCount / totalMandatorySteps) * 100);
        // Cap at 100% even if knowledge step is completed
        return Math.min(percentage, 100);
    }
    getMessageClass() {
        return this.message ? `alert alert-${this.message.type}` : 'hidden';
    }
    getLoadingClass() {
        return this.isLoading ? 'active' : 'hidden';
    }
    // Tab management methods
    switchToProfessionTab() {
        this.activeTab = 'profession';
    }
    switchToStepByNumber(stepNumber) {
        // Find the step index by stepNumber, or handle knowledge step
        if (stepNumber === this.steps.length + 2) {
            // This is the knowledge step
            this.switchToStepTab(this.steps.length);
        }
        else {
            // Regular step - find by stepNumber
            const stepIndex = this.steps.findIndex(step => step.stepNumber === stepNumber);
            if (stepIndex !== -1) {
                this.switchToStepTab(stepIndex);
            }
        }
    }
    switchToStepTab(stepIndex) {
        this.currentStepIndex = stepIndex;
        if (stepIndex === this.steps.length) {
            // This is the knowledge upload step            
            this.activeTab = 'knowledge';
            this.currentQuestions = []; // No questions for knowledge step
        }
        else {
            // Regular step - use step ID for unique identification
            const step = this.steps[stepIndex];
            this.activeTab = step ? String(step.id) : `step-${stepIndex}`;
            if (step) {
                // Use questions from step data if available, otherwise load separately
                if (step.questions && step.questions.length > 0) {
                    // Force reactivity by creating a new array
                    const sortedQuestions = [...step.questions].sort((a, b) => a.order - b.order);
                    this.currentQuestions = sortedQuestions;
                }
                else {
                    this.loadQuestionsForStep(String(step.id));
                }
            }
        }
    }
    switchToStepById(stepId) {
        const stepIndex = this.steps.findIndex(step => String(step.id) === stepId);
        if (stepIndex !== -1) {
            this.switchToStepTab(stepIndex);
        }
    }
    async nextStep() {
        // Check if model is selected before proceeding to next step
        if (!this.avatarConfig.selectedModel || !this.avatarConfig.selectedModel.model) {
            this.popupService.alert('onboarding.error.model_required'.t());
            return;
        }
        // Mark current step as completed if it's a regular step
        if (!this.isKnowledgeStep() && !this.completedSteps.includes(this.currentStepIndex)) {
            this.completedSteps = [...this.completedSteps, this.currentStepIndex];
        }
        if (this.currentStepIndex < this.steps.length) {
            // Move to next step or knowledge step
            const nextIndex = this.currentStepIndex + 1;
            this.switchToStepTab(nextIndex);
            // Only save locally - don't send to server for intermediate steps
            // Server save only happens on final completion via saveOnboarding()
        }
        else {
            // This is the final step - save to server with completion            
            await this.saveOnboarding();
        }
    }
    async saveProgress() {
        var _a;
        if (!this.selectedProfessionId) {
            return;
        }
        try {
            const payload = {
                profession_id: this.selectedProfessionId,
                status: 'in_progress',
                current_step: this.currentStepIndex,
                completed_steps: this.completedSteps,
                data: {
                    answers: this.answers,
                    steps: this.steps.map(step => step.id)
                },
                knowledge_ids: this.knowledgeIds,
                avatar_config: this.avatarConfig
            };
            // Add avatar_id only if it exists
            if (this.avatarId) {
                payload.avatar_id = this.avatarId;
            }
            const response = this.onboardingId
                ? await this.apiService.back.put('onboarding.update', payload, {
                    routeParams: { id: String(this.onboardingId) }
                })
                : await this.apiService.back.post('onboarding.create', payload);
            if (response.success && !this.onboardingId) {
                this.onboardingId = ((_a = response.data) === null || _a === void 0 ? void 0 : _a.id) ? String(response.data.id) : null;
            }
        }
        catch (error) {
            console.error('Error saving progress:', error);
            // Don't show error message for progress saves to avoid interrupting UX
        }
    }
    async previousStep() {
        if (this.isKnowledgeStep()) {
            // From knowledge step, go to last regular step
            if (this.steps.length > 0) {
                const lastStepIndex = this.steps.length - 1;
                this.switchToStepTab(lastStepIndex);
            }
            else {
                this.switchToProfessionTab();
            }
        }
        else if (this.currentStepIndex > 0) {
            const prevIndex = this.currentStepIndex - 1;
            this.switchToStepTab(prevIndex);
        }
        else {
            // If at first step, go back to profession selection
            this.switchToProfessionTab();
        }
    }
};
exports.OnboardingWizard = OnboardingWizard;
__decorate([
    client_1.attr,
    __metadata("design:type", Object)
], OnboardingWizard.prototype, "avatarId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], OnboardingWizard.prototype, "professions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], OnboardingWizard.prototype, "steps", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], OnboardingWizard.prototype, "currentQuestions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], OnboardingWizard.prototype, "selectedProfessionId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], OnboardingWizard.prototype, "currentStepIndex", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], OnboardingWizard.prototype, "answers", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], OnboardingWizard.prototype, "completedSteps", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], OnboardingWizard.prototype, "knowledgeIds", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_d = typeof backendImport_1.IFile !== "undefined" && backendImport_1.IFile) === "function" ? _d : Object)
], OnboardingWizard.prototype, "avatarLogo", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], OnboardingWizard.prototype, "avatarConfig", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], OnboardingWizard.prototype, "isLoading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], OnboardingWizard.prototype, "message", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], OnboardingWizard.prototype, "onboardingId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], OnboardingWizard.prototype, "activeTab", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], OnboardingWizard.prototype, "totalStepsWithKnowledge", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], OnboardingWizard.prototype, "voiceOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], OnboardingWizard.prototype, "selectedAzureVoice", void 0);
exports.OnboardingWizard = OnboardingWizard = __decorate([
    (0, client_1.RWSView)('onboarding-wizard', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(StorageService_1.default)),
    __param(1, (0, client_1.RWSInject)(SignalService_1.default)),
    __param(2, (0, client_1.RWSInject)(PopupService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof StorageService_1.StorageServiceInstance !== "undefined" && StorageService_1.StorageServiceInstance) === "function" ? _a : Object, typeof (_b = typeof SignalService_1.SignalServiceInstance !== "undefined" && SignalService_1.SignalServiceInstance) === "function" ? _b : Object, typeof (_c = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _c : Object])
], OnboardingWizard);
OnboardingWizard.defineComponent();
